import { GridFilterOperator } from "@mui/x-data-grid-pro";
import { EntityMappings } from "graphqlBase/__utils__/entityMappings";
import { FiltertypesWrapped } from "./types";
import makeFilters from "./utils/makeFilters";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function makeSeverSideFilterPre<D extends object, E extends keyof EntityMappings>() {
  return function <T extends keyof FiltertypesWrapped>(
    filterType: T,
    {
      filterOperators,
      filterPath,
    }: {
      filterOperators?: GridFilterOperator[];
      filterPath: ({
        where,
        filterValue,
      }: {
        filterValue: FiltertypesWrapped[T];
        where: EntityMappings[E]["filter"];
      }) => EntityMappings[E]["filter"] | undefined | null;
    }
  ) {
    return {
      filterPath,
      filterOperators: filterOperators ?? makeFilters[filterType],
    };
  };
}
